import Selector from "./Selector";

function ConnectedDestinationMeans({ data, Start, Destination, passData }) {
  if (Start !== "" && Destination !== "") {
    let filteredData = data.filter((obj, i) => {
      if (obj["Πληροφορίες στο χρήστη"].length < 100) {
        return obj["Προέλευση"] === Start && obj["Προορισμός"] === Destination;
      }
    });

    let SelectorData = filteredData.map((obj, i) => {
      return obj["Μέσο Μετακίνησης προς Προορισμό"][0];
    });

    let FinSelectorData = SelectorData.map((x) => ({ value: x, label: x }));

    let ConnectedStartMeansSelector = {
      title: "Επιλέξτε Μέσο από Ενδιάμεσο Προορισμό",
      defaultText: "Επιλογή από τη λίστα",
      options: FinSelectorData,
    };

    return <Selector props={ConnectedStartMeansSelector} onSelect={passData} />;
  } else {
    return <></>;
  }
}

export default ConnectedDestinationMeans;
